// The persistent environment banner (SM-752): on every page, the login
// page included. The static text is fixed; before sign-in the label comes
// from the guard's public probe, after it the label and scenario epoch
// come from GET /mock-admin/environment.
import { useQuery } from "@tanstack/react-query";
import { fetchers, keys } from "@/lib/queries";
import { SANDBOX_BANNER } from "@/lib/sandboxGuard";

export function EnvBanner({ signedIn }: { signedIn: boolean }) {
  const env = useQuery({
    queryKey: keys.environment(),
    queryFn: fetchers.environment,
    enabled: signedIn,
    staleTime: 10_000,
    refetchInterval: signedIn ? 30_000 : false,
  });
  // already in the cache: the root guard probed it before anything rendered
  const pub = useQuery({ queryKey: keys.publicEnvironment(), queryFn: fetchers.publicEnvironment, staleTime: 60_000 });
  return (
    <div className="env-banner" role="banner" aria-label="Environment">
      <span className="env-banner-text">{SANDBOX_BANNER}</span>
      <span className="env-banner-meta">
        {signedIn && env.data ? (
          <>
            <span>
              env <b>{env.data.environment_label}</b>
            </span>
            <span>
              epoch <b>{env.data.epoch}</b>
            </span>
            {env.data.clock?.mode && env.data.clock.mode !== "real" && (
              <span>
                clock <b>{env.data.clock.mode}</b>
              </span>
            )}
          </>
        ) : (
          <>
            {pub.data && (
              <span>
                env <b>{pub.data.environment_label}</b>
              </span>
            )}
            <span>no real funds · no production credentials</span>
          </>
        )}
      </span>
    </div>
  );
}
